import "./Component7.css"

export default function Component7({data}){
    return <></>
}